import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Headline from '../../../atoms/headline/headline';
import Container from '../../../layout/container/container';
import StyledEducationTabletProcess from './educationTabletProcess.style';
import EducationTabletCard from '../../../molecules/education/tablet-card/educationTabletCard';

function EducationTabletProcess({ educationTopics, educationType, workshopSteps, slug }) {
  return (
    <StyledEducationTabletProcess>
      <Container large>
        {workshopSteps ? (
          <>
            <div className="process__header">
              <Headline tag="h2" secondary>
                Ablauf
              </Headline>
            </div>
            <div className="process__grid">
              {workshopSteps.map((item, index) => {
                return (
                  <EducationTabletCard
                    key={item.id}
                    number={index + 1}
                    duration={item.duration}
                    educationTopics={educationTopics}
                    educationType={educationType}
                    headline={item.headline}
                    copy={item.introCopy}
                    slug={`/bildung/detail/${slug}/steps?step=${index + 1}`}
                  />
                );
              })}
            </div>
          </>
        ) : (
          <Headline tag="h2" secondary>
            Keine Einträge gefunden
          </Headline>
        )}
      </Container>
    </StyledEducationTabletProcess>
  );
}

EducationTabletProcess.propTypes = {
  workshopSteps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      duration: PropTypes.number.isRequired,
      headline: PropTypes.string.isRequired,
      introCopy: PropTypes.string.isRequired
    })
  ).isRequired,
  educationTopics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  educationType: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired,
  slug: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  workshopSteps: state.app.pageData.workshopSteps,
  educationTopics: state.app.pageData.educationTopics,
  educationType: state.app.pageData.educationType,
  slug: state.app.pageData.slug
});

export default connect(mapStateToProps)(EducationTabletProcess);
